module.exports = __webpack_public_path__ + "img/new-axelerate-logo.02a2fab3.svg";